export default __webpack_public_path__ + "static/BannerOpaco-e102df3b31ef7fbb8c786d71a525fe18.png";